export { default } from './parts-table';
